import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import { throwIfFailed } from "shared/dialogSubmit";
import ClientsStore from "./ClientsStore";

const clientsRoute: RouteType[] = [
  {
    name: "Clients",
    path: "/clients",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Clients",
        enableRefreshButton: true,
        component: () => import("./Clients.Header"),
      },
      body: {
        component: () => import("./Clients.Body"),
        grayBackground: true,
      },
    },
    group: "Clients",
    // RBAC seam: reads require authentication only. The API service enforces
    // the operator-or-admin gate on writes; this route is intentionally not
    // admin-only so viewers can browse the client list. Tighten per-tier here
    // when the viewer/operator/admin RBAC framework lands (see API hooks).
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      // Loads the current page (server-side query), the client-summary /
      // client-health rollups + headline counts, and subscribes to live
      // `clients` CRUD events (idempotent — the header Refresh re-runs this).
      const store = rootStore.clientsViewStore as ClientsStore;
      void store?.initialize();
    },
    onExit: ({ rootStore }) => {
      // Tear down the realtime subscription (refcounted shared socket).
      const store = rootStore.clientsViewStore as ClientsStore;
      store?.dispose();
    },
    dialogs: [
      {
        name: "ClientFormDialog",
        title: "Client",
        submitButtonText: "Create client",
        component: () => import("./dialogs/ClientForm.Body"),
        cancelButton: true,
        height: 640,
        onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
          // A refused save throws, so the dialog stays open with the reason in
          // its footer (shared/dialogSubmit).
          const store = rootStore.clientsViewStore as ClientsStore;
          throwIfFailed(await store.saveClient(), store.formError, "The client could not be saved.");
        },
        onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
          const store = rootStore.clientsViewStore as ClientsStore;
          return store.isFormValid;
        },
      },
    ],
  },
];

export default clientsRoute;
